import { render, staticRenderFns } from "./SourceCallbackTest.vue?vue&type=template&id=216325b1&"
import script from "./SourceCallbackTest.vue?vue&type=script&lang=js&"
export * from "./SourceCallbackTest.vue?vue&type=script&lang=js&"
import style0 from "./SourceCallbackTest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports